import { Box, Button, Text } from '@chakra-ui/react';
import { RiDeleteBinLine } from 'react-icons/ri';
import { MdAddBox, MdOutlineQuickreply } from 'react-icons/md';
import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { BsCheck } from 'react-icons/bs';

export const Key = ({ props, notesUtils }) => {
  return (
    <Box display="flex" justifyContent="space-between">
      {props.stateProps.isAdmin && (
        <Box onClick={() => notesUtils.add()} cursor="pointer" color="0000FF" textDecoration="underline">Add Note</Box>
      )}
      <Box onClick={(e) => notesUtils.open()} cursor="pointer" color="0000FF" textDecoration="underline">Hide
        Notes</Box>
    </Box>
  );
};
export default Key;
/*
    <Box display="flex" justifyContent="space-between">
      <Box>
        <Text className="owner keyIcon">C</Text> = Counselor,&nbsp;
        <Text className="owner keyIcon">J</Text> = Job Seeker,&nbsp;
        <Text className="keyIcon greenHover"><RiDeleteBinLine /></Text> = Delete,&nbsp;
        <Text className="keyIcon greenHover"><MdAddBox /></Text> = new note.&nbsp;
        <Text className="keyIcon greenHover"><MdOutlineQuickreply /></Text> = Reply,&nbsp;
        {!props.stateProps.isAdmin && (
          <Text className="keyIcon">
            <Text className="keyIcon greenHover" color="red">*</Text> = Mark Done,&nbsp;
          </Text>
        )}
        <Box>Click on the note title or body to edit.</Box>
        <Box>Click <Text class="keyIcon sendEmail">Send Email</Text> to send comments to your counselor</Box>
      </Box>
    </Box>
 */